import { DEFAULT_REPORT_BLOCK_IDS, flagKeys, tabNames } from '@va/constants';
import { PageContent } from '@va/dashboard/shared/ui-layout';
import { useActiveTab } from '@va/dashboard/util-hooks';
import { isUserLoggedInWithCustomUrl } from '@va/standalone/shared/helpers';
import { getUserFlags, isAgencyOwner } from '@va/standalone/shared/selectors';

import { FiltersContextProvider } from '@va/shared/feature-filters';

import { GeneralErrorPage } from '@va/dashboard/ui/pages';
import { useSelector } from 'react-redux';
import { AgencyWhiteLabelContextProvider } from '../agency-white-label-v2/AgencyWhiteLabelContext';
import useWhiteLabelTabsFilterOptions from '../agency-white-label-v2/useWhiteLabelTabsFilterOptions';
import CommissionDetailsTable from './commission-details/CommissionDetailsTable';
import WelcomePageAgencyCommission from './welcome-page-agency-commission';

const AgencyCommission = () => {
  const flags = useSelector(getUserFlags);
  const agencyOwner = useSelector(isAgencyOwner);

  const isOnboardingFinished = flags[flagKeys.PREMIUM_COMMISSION_ONBOARDING_FINISHED];

  const filterOptions = useWhiteLabelTabsFilterOptions();

  useActiveTab(tabNames.agencyCommission);

  if (isUserLoggedInWithCustomUrl() && !agencyOwner) {
    return <GeneralErrorPage />;
  }

  return (
    <FiltersContextProvider
      reportBlockId={DEFAULT_REPORT_BLOCK_IDS.agencyCommisionTable}
      allFilterOptions={filterOptions}
    >
      <AgencyWhiteLabelContextProvider tab={tabNames.agencyCommission}>
        <PageContent>{isOnboardingFinished ? <CommissionDetailsTable /> : <WelcomePageAgencyCommission />}</PageContent>
      </AgencyWhiteLabelContextProvider>
    </FiltersContextProvider>
  );
};

export default AgencyCommission;
